import React from 'react'

import * as S from './styles'

const AdUnavailableSVG = '/assets/img/adUnavailable.svg'

const AdUnavailable = () => (
  <S.Container id="adUnavailable" data-test="adUnavailable">
    <S.Image src={AdUnavailableSVG} />
    <S.Title>
      Anúncio indisponível <br />
      no momento.
    </S.Title>
    <S.Message>
      Confira aqui embaixo anúncios recomendados e encontre a melhor oferta na
      Webmotors! ;)
    </S.Message>
  </S.Container>
)

export default AdUnavailable
